import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.function.name";
import _includes from "lodash/includes";
import _xor from "lodash/xor";
import _find from "lodash/find";
import _get from "lodash/get";
import _each from "lodash/each";
import _uniqueid from "lodash/uniqueId";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import classNames from 'classnames';
import Type from '@nerdwallet/react-typography';
import { CheckboxOption } from '@nerdwallet/react-checkbox';
import DropdownTrigger from '../dropdown-trigger';
import styles from './multiselect.module.less';
import { OPTION_PROPS } from '../prop-types';

var Multiselect = /*#__PURE__*/function (_Component) {
  _inherits(Multiselect, _Component);

  var _super = _createSuper(Multiselect);

  /*
    When wrapped in an InputGroup component this tells the InputGroup
    to use fieldset so that we won't have the child checkbox `<label>`'s wrapped
    in a parent label for the Multiselect. This causes odd behavior.
  */
  function Multiselect(props) {
    var _this;

    _classCallCheck(this, Multiselect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOptionChange", function (e) {
      var selectedValue = _get(e, 'target.value'); // _.xor() is basically _.toggle()


      var value = _xor(_this.props.value, [selectedValue]);

      _this.props.onChange({
        target: {
          value: value
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function () {
      // eslint-disable-next-line react/no-access-state-in-setstate -- directive added automatically by Shepherd migration
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOutsideDropdownClick", function (e) {
      var menuNode = _this.menu.current;
      var buttonNode = _this.button.current;

      if (menuNode.contains(e.target) || buttonNode.contains(e.target)) {
        return;
      }

      _this.toggleOpen();
    });

    _defineProperty(_assertThisInitialized(_this), "handleEscape", function (e) {
      var ESCAPE_KEY = 27;

      if (e.keyCode === ESCAPE_KEY && _this.state.isOpen) {
        _this.toggleOpen();
      }
    });

    var id = props.id,
        name = props.name;
    _this.state = {
      isOpen: false
    };
    _this.button = /*#__PURE__*/React.createRef();
    _this.menu = /*#__PURE__*/React.createRef(); // ensure the instance has an id and name to prevent unexpected option
    // selection behavior and to enhance accessibility

    _this.id = id || _uniqueid();
    _this.name = name || _uniqueid();
    return _this;
  }

  _createClass(Multiselect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      if (prevState.isOpen !== this.state.isOpen) {
        this.configureComponentListeners(this.state.isOpen);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.configureComponentListeners(false);
    }
  }, {
    key: "getLabelForValue",
    value: function getLabelForValue(value, options) {
      var _this2 = this;

      if (options && options.length > 0 && options[0].options) {
        var label = '';

        _each(options, function (groupOption) {
          label = label === '' ? _this2.getLabelForValue(value, groupOption.options) : label;
        });

        return label;
      }

      return _get(_find(options, function (option) {
        return option.value === value;
      }), 'label', '');
    }
  }, {
    key: "getSelectionText",
    value: function getSelectionText(value, options) {
      switch (value.length) {
        case 0:
          return 'Select one or multiple';

        case 1:
          return this.getLabelForValue(value[0], options);

        default:
          return "".concat(value.length, " selected");
      }
    }
  }, {
    key: "configureComponentListeners",
    value: function configureComponentListeners(isOpen) {
      if (isOpen) {
        // listen for escape character when menu is open
        document.addEventListener('keydown', this.handleEscape); // listen for click outside to close the menu when appropriate

        document.addEventListener('click', this.handleOutsideDropdownClick);
      } else {
        document.removeEventListener('keydown', this.handleEscape);
        document.removeEventListener('click', this.handleOutsideDropdownClick);
      }
    }
  }, {
    key: "renderSelectLabel",
    value: function renderSelectLabel() {
      var _this$props = this.props,
          options = _this$props.options,
          value = _this$props.value,
          disabled = _this$props.disabled;
      var color = Array.isArray(value) && value.length > 0 && !disabled ? 'neutral-darkest' : 'neutral-darker';
      return /*#__PURE__*/React.createElement(Type, {
        color: color
      }, this.getSelectionText(value, options));
    }
  }, {
    key: "renderOption",
    value: function renderOption(option) {
      var name = this.name,
          id = this.id;
      var label = option.label,
          value = option.value,
          disabled = option.disabled;
      return /*#__PURE__*/React.createElement("li", {
        key: "option__".concat(label, "__").concat(value)
      }, /*#__PURE__*/React.createElement(CheckboxOption, {
        value: value,
        label: label,
        name: name,
        id: "".concat(name, "--").concat(option.label, "-").concat(option.value, "--").concat(id),
        "aria-controls": id,
        className: styles.checkbox,
        disabled: disabled,
        onChange: this.handleOptionChange,
        checked: _includes(this.props.value, value)
      }));
    }
  }, {
    key: "renderGroupOption",
    value: function renderGroupOption(groupOption) {
      var _this3 = this;

      var items = groupOption.options.map(function (o) {
        return _this3.renderOption(o);
      });
      var title = /*#__PURE__*/React.createElement("li", {
        key: "title__".concat(groupOption.title)
      }, /*#__PURE__*/React.createElement(Type, {
        bold: true,
        className: styles.groupLabel
      }, groupOption.title));
      items.unshift(title);
      return items;
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this4 = this,
          _classNames;

      var options = this.props.options;
      var items = options.map(function (option) {
        if (option.options) {
          return _this4.renderGroupOption(option);
        }

        return _this4.renderOption(option);
      });
      return /*#__PURE__*/React.createElement("div", {
        ref: this.menu,
        className: classNames((_classNames = {}, _defineProperty(_classNames, styles.openOptions, this.state.isOpen), _defineProperty(_classNames, styles.openOptionsError, this.props.error && this.state.isOpen), _classNames), styles.optionContainer)
      }, this.state.isOpen && /*#__PURE__*/React.createElement("ul", {
        className: styles.list
      }, items));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          error = _this$props2.error,
          fullWidth = _this$props2.fullWidth,
          innerRef = _this$props2.innerRef,
          onBlur = _this$props2.onBlur,
          onFocus = _this$props2.onFocus;
      var containerClasses = classNames(className, styles.container, _defineProperty({}, styles.fullWidth, fullWidth));
      return /*#__PURE__*/React.createElement("div", {
        className: containerClasses,
        ref: innerRef
      }, /*#__PURE__*/React.createElement(DropdownTrigger, {
        mode: "button",
        ref: this.button,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        onClick: this.toggleOpen,
        onFocus: onFocus,
        onBlur: onBlur
      }, this.renderSelectLabel()), this.renderOptions());
    }
  }]);

  return Multiselect;
}(Component);

_defineProperty(Multiselect, "displayName", 'Multiselect');

_defineProperty(Multiselect, "defaultProps", {
  className: null,
  disabled: false,
  error: false,
  fullWidth: false,
  id: '',
  name: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {}
});

_defineProperty(Multiselect, "shouldUseFieldset", true);

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types'); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  Multiselect.propTypes = {
    /* custom className for multiselect */
    className: PropTypes.string,

    /* controls whether the multiselect is disabled */
    disabled: PropTypes.bool,

    /* controls the visual error state */
    error: PropTypes.bool,

    /* id of the multiselect */
    id: PropTypes.string,

    /* controls if multiselect should be full width */
    fullWidth: PropTypes.bool,

    /* Used as a name attribute for the underlying <CheckboxOption />. */
    name: PropTypes.string,

    /* callback for onBlur */
    onBlur: PropTypes.func,

    /* callback for onChange */
    onChange: PropTypes.func,

    /* callback for onFocus */
    onFocus: PropTypes.func,

    /* options for user to select */
    options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape(OPTION_PROPS)), PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      options: OPTION_PROPS
    }))]).isRequired,

    /* currently selected value */
    value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired
  };
}

export default Multiselect;